/* BLANC SPACE CUSTOM — live Loox aggregate rating for the homepage review strip. */

class LooxHomeReviewSummary extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true' || !this.dataset.storeId) return;

    this.dataset.initialized = 'true';
    this.requestController = new AbortController();
    this.loadBottomline();
  }

  disconnectedCallback() {
    this.requestController?.abort();
  }

  async loadBottomline() {
    const storeId = encodeURIComponent(this.dataset.storeId);
    const url = `https://storefront-api.loox.io/storefront/v1/store/${storeId}/product-reviews/bottomline`;

    try {
      const response = await fetch(url, { signal: this.requestController.signal });
      if (!response.ok) throw new Error(`Loox bottomline request failed (${response.status})`);

      const bottomline = await response.json();
      this.renderBottomline(bottomline);
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.warn('[Blanc Space] Homepage Loox review totals unavailable.', error);
      }
    }
  }

  renderBottomline(bottomline) {
    const total = Number(bottomline.totalReviews) || 0;
    const average = Number(bottomline.averageRating) || 0;
    if (!total || !average) return;

    const locale = this.dataset.locale || 'en';
    const formatter = new Intl.NumberFormat(locale);
    const headingTotal = total >= 1000 ? Math.floor(total / 1000) * 1000 : total;
    const heading = this.querySelector('[data-loox-review-heading]');
    const averageNode = this.querySelector('[data-loox-review-average]');
    const countNode = this.querySelector('[data-loox-review-count]');
    const stars = this.querySelector('[data-loox-review-stars]');

    if (heading) heading.textContent = `Over ${formatter.format(headingTotal)} reviews`;
    if (averageNode) averageNode.textContent = average.toFixed(1);
    if (countNode) countNode.textContent = formatter.format(total);
    if (stars) stars.setAttribute('aria-label', `${average.toFixed(1)} out of 5 stars`);
  }
}

if (!customElements.get('loox-home-review-summary')) {
  customElements.define('loox-home-review-summary', LooxHomeReviewSummary);
}
